<template>
  <div>
    <el-form ref="form" :model="form" label-width="120px" size="mini">
      <el-form-item label="UID：">
        <el-input v-model="form.uid" style="width: 172px"></el-input>
      </el-form-item>
      <el-form-item label="上报节点：">
        <el-select v-model="form.uploadPoint">
          <el-option
            v-for="item in uploadPointOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日志类型：">
        <el-select v-model="form.logType">
          <el-option
            v-for="item in logTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日期范围：">
        <el-date-picker
          v-model="form.selectedDateRange"
          :picker-options="dateRangePickerOptions"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="onClickQueryBtn()"
          >查询</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      :data="logTableData"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="logTableData.length == 0"
      border
      size="small"
      height="500px"
      style="width: 670px; margin-left: 120px; margin-top: 30px"
    >
      <el-table-column prop="when" label="时间" align="center" width="160">
      </el-table-column>
      <el-table-column
        prop="uploadPoint"
        label="上报节点"
        align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" width="100">
      </el-table-column>
      <el-table-column prop="items" label="道具" align="center" width="250">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const moment = require("moment");
const util = require("../../util");

export default {
  data() {
    return {
      shouldEditGreyListEntryDialogVisible: false, // “添加/修改灰名单项”对话框是否应该显示出来
      valueForEditGreyListEntryDialog: null, // 要传递给“添加/修改灰名单项”对话框的数据
      logTableData: [], // 日志列表里展示的数据
      availableUploadPoints: [], // 所有日志上报节点的定义
      availableLogTypes: [
        // 所有日志类型的定义
        {
          type: 0,
          desc: "<所有>",
        },
        {
          type: 1,
          desc: "产出",
        },
        {
          type: 2,
          desc: "消耗",
        },
      ],
      form: {
        uid: "",
        uploadPoint: 0,
        logType: 0,
        selectedDateRange: [],
      },
    };
  },

  async created() {
    // 从url当中读取部分参数
    this.form.uid = this.$router.currentRoute.query.uid;

    // 取得所有的日志上报节点
    await this.loadAvailableUploadPoints();
  },

  computed: {
    uploadPointOptions() {
      let options = [];

      for (let e of this.availableUploadPoints) {
        options.push({
          value: e.id,
          label: e.name,
        });
      }

      return options;
    },

    logTypeOptions() {
      let options = [];

      for (let e of this.availableLogTypes) {
        options.push({
          value: e.type,
          label: e.desc,
        });
      }

      return options;
    },

    dateRangePickerOptions() {
      return {
        firstDayOfWeek: 1, // 以周一作为一周的第一天
        disabledDate(date) {
          // 今天以后的日期不能选
          return (
            moment(date).format("yyyy-MM-DD") > moment().format("yyyy-MM-DD")
          );
        },
      };
    },
  },

  methods: {
    loadMore() {
      this.loadLogList(this.logTableData.length, 20);
    },

    /**
     * 查询日志列表
     */
    async loadLogList(skip, limit) {
      let uid = parseInt(this.form.uid);
      if (isNaN(uid) || uid <= 0) {
        this.$message({
          message: "请填入正确的UID",
          type: "error",
        });
        return;
      }

      if (this.form.selectedDateRange.length == 0) {
        this.$message({
          message: "请选择日期范围",
          type: "error",
        });
        return;
      }

      let startAt = moment(this.form.selectedDateRange[0]).valueOf();
      let endAt = moment(this.form.selectedDateRange[1])
        .add(1, "day")
        .valueOf();

      // 如果是要从头开始拉（而不是继续拉剩下的），那就先清空原有记录
      if (skip == 0) {
        this.logTableData = [];
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/getClientLog`,
          {
            uid: uid,
            startAt: startAt,
            endAt: endAt,
            skip: skip,
            limit: limit,
            uploadPointType: this.form.uploadPoint,
            type: this.form.logType,
          },
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let listInResp = resData.data.logs || [];

      let list = [];
      for (let log of listInResp) {
        let items = "";
        for (let i = 0; i < log.items.length; i++) {
          items += `<${log.items[i].itemId}: ${log.items[i].number}>`;
          if (i < log.items.length - 1) {
            items += "; ";
          }
        }

        let uploadPoint = "";
        for (let e of this.availableUploadPoints) {
          if (e.id == log.type) {
            uploadPoint = e.name;
          }
        }

        let logType = "";
        for (let e of this.availableLogTypes) {
          if (e.type == log.type) {
            logType = e.desc;
          }
        }

        list.push({
          when: moment(parseInt(log.time)).format("yyyy-MM-DD HH:mm:ss"),
          uploadPoint: uploadPoint,
          type: logType,
          items: items,
        });
      }

      this.logTableData = this.logTableData.concat(list);
    },

    /**
     * 取得所有的上报节点
     */
    async loadAvailableUploadPoints() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/getLogOutputPointList`,
          {},
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let listInResp = resData.data.outputPointList || [];

      this.availableUploadPoints = [
        {
          id: 0,
          name: "<所有>",
        },
      ];

      for (let e of listInResp) {
        this.availableUploadPoints.push({
          id: e.id,
          name: e.name,
        });
      }
    },

    /**
     * 点击了查询按钮
     */
    async onClickQueryBtn() {
      await this.loadLogList(0, 20);
    },
  },
};
</script>